/**
 * Utilities specific for rendering Adaptive Cards
 */

import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

export function substitutedString(originalString: any, inputs: any) {
  let processedString = originalString

  const regEx = /\{{2}([a-z0-9_$@]+).value\}{2}/gi
  let matches

  while ((matches = regEx.exec(originalString))) {
    const matchedInput = inputs[matches[1]]

    processedString = processedString.replace(matches[0], matchedInput || '')
  }

  return processedString
}

export function createSpacing(theme: any, orientation: any, spacing: any, lineThickness: any, lineColor: any) {
  const styles = {
    // display: 'flex'
  }
  if (orientation === 'horizontal') {
    if (lineThickness) {
      // @ts-expect-error
      styles.marginTop = spacing / 2
      // @ts-expect-error
      styles.paddingTop = spacing / 2
      // @ts-expect-error
      styles.borderTopStyle = 'solid'
      // @ts-expect-error
      styles.borderTopWidth = lineThickness
      // @ts-expect-error
      styles.borderTopColor = themeUtilities.getRgbaColor(theme, lineColor)
    } else {
      // @ts-expect-error
      styles.marginTop = spacing
    }
  } else {
    if (lineThickness) {
      // @ts-expect-error
      styles.marginLeft = spacing / 2
      // @ts-expect-error
      styles.paddingLeft = spacing / 2
      // @ts-expect-error
      styles.borderLeftStyle = 'solid'
      // @ts-expect-error
      styles.borderLeftWidth = lineThickness
      // @ts-expect-error
      styles.borderLeftColor = themeUtilities.getRgbaColor(theme, lineColor)
    } else {
      // @ts-expect-error
      styles.marginLeft = spacing
    }
  }

  return styles
}
